/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  releaseDate: "05JAN26",

  //Local
  //endpoint: 'http://localhost:4040',  
  
  //Production
  endpoint: 'https://odrtechapi.app/happyhotel',          dev_environment: false,

  //Dev
  // endpoint: 'https://odrtechinc.app/happyhotelsdev',           dev_environment: true,

  // endpoint_tourmind: 'https://odrtechinc.app/hhdevv7',


  // endpoint: 'https://localhost:44325/', dev_environment: true,
};
